import { render } from "./ActionMenu.vue?vue&type=template&id=6fb9285c&scoped=true&lang=pug"
import script from "./ActionMenu.vue?vue&type=script&lang=js"
export * from "./ActionMenu.vue?vue&type=script&lang=js"

import "./ActionMenu.vue?vue&type=style&index=0&id=6fb9285c&lang=scss&scoped=true"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fb9285c"]])

export default __exports__